{
  "min": -100,
  "max": 246,
  "R": [0, 128, 159, 255, 255, 255, 255],
  "G": [0, 0, 56, 90, 0, 255, 255],
  "B": [0, 0, 41, 70, 0, 0, 255],
  "A": [0, 63, 105, 135, 167, 184, 228],
  "I": [0, 100, 128, 155, 180, 209, 255]
}
